// Step 1 / hierarchy — collapses the dozen usePermission() calls the
// layout shell needs into a single hook so Layout itself reads as a
// clean orchestrator rather than a wall of permission lookups.
import { usePermission } from "../../permission"

export interface LayoutPermissions {
  dashboard: boolean
  // Buyer-side
  orderEdit: boolean
  orderSave: boolean
  orderSend: boolean
  netList: boolean
  list: boolean
  // Buyer returns surface (mvp-returns Phase 2 — gated on RETURN_VIEW)
  returnView: boolean
  // Supplier-side
  split: boolean
  backOrder: boolean
  dropshipping: boolean
  dnDraftList: boolean
  dnAssignedList: boolean
  dnDeliveredList: boolean
  psList: boolean
  // Орлого page gate (IBN_CREATE: list/get/exceptions) and Тээвэр page gate (BIZ_GOV_VIEW: vehicle list/get)
  inboundView: boolean
  vehicleView: boolean
  // Hub tabs served to ORD_DN_MNG / DEL_ROUTE_PLAN (failed, COD, routes) and Тохиргоо reads
  dnMng: boolean
  routePlan: boolean
  settingsView: boolean
  // Raw access guard for the default-page redirect
  dashboardGuard: { hasAccess: boolean; text: string }
}

export function useLayoutPermissions(): LayoutPermissions {
  const ORD_DASH = usePermission("ORD_DASH")
  const ORD_LIST = usePermission("ORD_LIST")
  const ORD_NET_LIST = usePermission("ORD_NET_LIST")
  const ORD_PS_LIST = usePermission("ORD_PS_LIST")
  const ORD_SPLIT = usePermission("ORD_SPLIT")
  const ORD_BCK_ORD = usePermission("ORD_BCK_ORD")
  const ORD_DRSHPING = usePermission("ORD_DRSHPING")
  const ORD_DN_DRAFT_LIST = usePermission("ORD_DN_DRAFT_LIST")
  const ORD_DN_ASSIGNED_LIST = usePermission("ORD_DN_ASSIGNED_LIST")
  const ORD_DN_DELIVERED_LIST = usePermission("ORD_DN_DELIVERED_LIST")
  const ORD_EDIT = usePermission("ORD_EDIT")
  const ORD_SAVE = usePermission("ORD_SAVE")
  const ORD_SEND = usePermission("ORD_SEND")
  const RETURN_VIEW = usePermission("RETURN_VIEW")
  const IBN_CREATE = usePermission("IBN_CREATE")
  const BIZ_GOV_VIEW = usePermission("BIZ_GOV_VIEW")
  const ORD_DN_MNG = usePermission("ORD_DN_MNG")
  const DEL_ROUTE_PLAN = usePermission("DEL_ROUTE_PLAN")
  const LOG_SIZE_MNG = usePermission("LOG_SIZE_MNG")
  const LOG_CLASS_RULE_MNG = usePermission("LOG_CLASS_RULE_MNG")

  return {
    dashboard: ORD_DASH.hasAccess,
    orderEdit: ORD_EDIT.hasAccess,
    orderSave: ORD_SAVE.hasAccess,
    orderSend: ORD_SEND.hasAccess,
    netList: ORD_NET_LIST.hasAccess,
    list: ORD_LIST.hasAccess,
    returnView: RETURN_VIEW.hasAccess,
    split: ORD_SPLIT.hasAccess,
    backOrder: ORD_BCK_ORD.hasAccess,
    dropshipping: ORD_DRSHPING.hasAccess,
    dnDraftList: ORD_DN_DRAFT_LIST.hasAccess,
    dnAssignedList: ORD_DN_ASSIGNED_LIST.hasAccess,
    dnDeliveredList: ORD_DN_DELIVERED_LIST.hasAccess,
    psList: ORD_PS_LIST.hasAccess,
    inboundView: IBN_CREATE.hasAccess,
    vehicleView: BIZ_GOV_VIEW.hasAccess,
    dnMng: ORD_DN_MNG.hasAccess,
    routePlan: DEL_ROUTE_PLAN.hasAccess,
    settingsView: BIZ_GOV_VIEW.hasAccess || LOG_SIZE_MNG.hasAccess || LOG_CLASS_RULE_MNG.hasAccess,
    dashboardGuard: { hasAccess: ORD_DASH.hasAccess, text: ORD_DASH.text },
  }
}
